<template>
  <div>
    <h1>
      Contractor Application Search
    </h1>

    <div id="overlay" v-if="fetchingData">
      <div class="spinner"></div>
    </div>

    <div class="row justify-content-center">
      <div class="col-12 col-md-6">
        <div class="form-group">
          <base-input v-model="applicationNumber"
                      label="Contractor IDPH Number"
                      mask="###-####"
                      v-focus
                      v-on:keyup.enter="searchAppNumber" />
        </div>
        <button class="btn btn-primary" @click="searchAppNumber">Search</button>
      </div>
    </div>
  </div>
</template>

<script>
import BaseInput from '~/components/BaseInput';
import { getContractorRegistration } from '~/js/FormFunctions';
import { ContractorApplication } from '@/js/FormObjects';

export default {
  name: 'ContractorApplicationSearch',
  components: { BaseInput },
  directives: {
    focus: {
      inserted(el) {
        const inputEl = el.querySelector('input');
        inputEl.focus(inputEl);
      },
    },
  },
  data() {
    return {
      applicationNumber: null,
      fetchingData: false,
      error: null,
    };
  },
  methods: {
    searchAppNumber() {
      const self = this;
      this.fetchingData = true;
      getContractorRegistration(this.applicationNumber)
        .then((data) => {
          const form = new ContractorApplication(data);
          self.$store.commit('temporaryForm', form);
          self.$router.push({ name: 'AsbestosContractor', params: { isRenewal: true } });
        })
        .catch((error) => {
          this.error = error;
          self.fetchingData = false;

          if (error.response) {
            this.$notify(`Error getting contractor registration record: ${error.response.data.message}`, 'error');
          } else if (error.request) {
            this.$notify(`Error getting contractor registration record: ${error.request}`, 'error');
          } else {
            self.$notify(`Error getting contractor registration record: ${error.message}`, 'error');
          }
        });
    },
  },
};
</script>
